<template>
    <div class="app_title">
        <h1>{{ title }}</h1>
        <div class="app_title__content">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        title: {type: String, required: true}
    }
}
</script>

<style lang="scss" scoped>

.app_title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 83px;

    h1 {
        font: {
            weight: 700;
            size: 32px;
        };
        letter-spacing: -2px;
    }
}
</style>